module.exports = __webpack_public_path__ + "media/images/thumbs/pathophys/1kIOvf5EcJS2U3zSsSS9fZ-a3e21d8802045150d0d8d13f299a63fb.jpg";